import { ADD_PAGE_LOADER, REMOVE_PAGE_LOADER } from './constants';

const initialState = {
  isLoading: false,
};

const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PAGE_LOADER:
      return {
        ...state,
        isLoading: true,
      };

    case REMOVE_PAGE_LOADER:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default generalReducer;
